import {Route, Routes} from 'react-router-dom';
import Dashboard from './Owner/Pages/Dashboard';
import Locations from './Owner/Pages/Locations';
import Vehicles from './Owner/Pages/Vehicles';
import LocationEdit from './Owner/Pages/LocationEdit';
import VehicleEdit from './Owner/Pages/VehicleEdit';
import NotFound from './Owner/Pages/NotFound';
import HomePage from "./Front/Pages/HomePage";
import LocationPage from "./Front/Pages/LocationPage";
import AccessoiresPage from "./Front/Pages/AccessoiresPage";
import AccessoiresOrderResultPage from "./Front/Pages/AccessoiresOrderResultPage";
import ReservationInitPage from "./Front/Pages/Reservation/ReservationInitPage";
import ExternalRentRedirectPage from "./Front/Pages/Reservation/ExternalRentRedirectPage";
import ReservationOptions from "./Front/Pages/Reservation/ReservationOptions";
import ReservationConfirmPage from "./Front/Pages/Reservation/ReservationConfirmPage";
import ReservationRegisterPage from "./Front/Pages/Reservation/ReservationRegisterPage";
import ReservationResultPage from "./Front/Pages/Reservation/ReservationResultPage";
import VoorVerhuurbedrijvenPage from "./Front/Pages/VoorVerhuurbedrijvenPage";
import VoorParticulierenPage from "./Front/Pages/VoorParticulierenPage";
import AnalyticsTracker from "./Front/ThemeComponents/AnalyticsTracker";
import Sentry from "./Front/config/sentry";

// Names Sentry transactions after the matched route (e.g. /reservation/:vehicleId/:locationId).
const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

function App() {
    return (
        <>
            <AnalyticsTracker />
            <SentryRoutes>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/accessoires" element={<AccessoiresPage/>}/>
                <Route path="/accessoires/result/:orderId" element={<AccessoiresOrderResultPage/>}/>
                <Route path="/locations/:id/:vehicleType" element={<LocationPage/>}/>
                <Route path="/external-rent/:subsidiaryId/:vehicleExternalId" element={<ExternalRentRedirectPage/>}/>
                <Route path="/reservation/:vehicleId/:locationId" element={<ReservationInitPage/>}/>
                <Route path="/reservation-options/:vehicleId/:locationId" element={<ReservationOptions/>}/>
                <Route path="/reservation-confirm/:vehicleId/:locationId" element={<ReservationConfirmPage/>}/>
                <Route path="/reservation-register/:vehicleId/:locationId" element={<ReservationRegisterPage/>}/>
                <Route path="/reservation-result/:vehicleId/:locationId" element={<ReservationResultPage/>}/>
                <Route path="/voor-verhuurbedrijven" element={<VoorVerhuurbedrijvenPage/>}/>
                <Route path="/voor-particulieren" element={<VoorParticulierenPage/>}/>

                <Route path="/backoffice" element={<Dashboard/>}/>
                <Route path="/backoffice/locations" element={<Locations/>}/>
                <Route path="/backoffice/locetions/:id" element={<LocationEdit/>}/>
                <Route path="/backoffice/vehicles" element={<Vehicles/>}/>
                <Route path="/backoffice/vehicles/:id" element={<VehicleEdit/>}/>
                <Route path="*" element={<NotFound/>}/>
            </SentryRoutes>
        </>
    );
}

export default App;
